import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const AdvertiseForm = defineAsyncComponent(() => import('@/js/exposure/AdvertiseForm.vue'));
const AdvertiseInput = defineAsyncComponent(() => import('@/js/exposure/AdvertiseInput.vue'));

app.component('AdvertiseForm', AdvertiseForm);
app.component('AdvertiseInput', AdvertiseInput);

mountApp();

document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;
    const SCROLL_DELAY_MS = 1500;

    if (hash) {
        setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, SCROLL_DELAY_MS);
    }
});
